export enum BaseModulePaths {
  Home = '',
  Members = 'members',
  Counselors = 'counselors',
  FirstResponders = 'first-responders',
  VersionError = 'version-error',
  Register = 'register',
  ResetPassword = 'reset-password',
  ValidatePassword = 'validate-password',
  ValidateEmail = 'validate-email',
  ValidateAgentPassword = 'validate-counselor-email',
  AgentPasswordExpired = 'agent-password-expired',
  AccountDeleted = 'account-deleted',
  Passthrough = 'credentials/pass-through',
  PrivacyPolicy = 'privacy-policy',
  TermsOfService = 'terms-of-service',
  DataProcessingAddendum = 'data-processing-addendum',
  App = 'app'
}

export const BasePaths = {
  Home: BaseModulePaths.Home,
  Members: `/${BaseModulePaths.Members}`,
  Counselors: `/${BaseModulePaths.Counselors}`,
  FirstResponders: `/${BaseModulePaths.FirstResponders}`,
  VersionError: `/${BaseModulePaths.VersionError}`,
  Register: `/${BaseModulePaths.Register}`,
  ResetPassword: `/${BaseModulePaths.ResetPassword}`,
  ValidatePassword: `/${BaseModulePaths.ValidatePassword}`,
  ValidateEmail: `/${BaseModulePaths.ValidatePassword}`,
  ValidateAgentPassword: `/${BaseModulePaths.ValidateAgentPassword}`,
  AgentPasswordExpired: `/${BaseModulePaths.AgentPasswordExpired}`,
  AccountDeleted: `/${BaseModulePaths.AccountDeleted}`,
  Passthrough: `/${BaseModulePaths.Passthrough}`,
  PrivacyPolicy: `/${BaseModulePaths.PrivacyPolicy}`,
  TermsOfService: `/${BaseModulePaths.TermsOfService}`,
  DataProcessingAddendum: `/${BaseModulePaths.DataProcessingAddendum}`,
  App: `/${BaseModulePaths.App}`
};

export enum AgentModulePaths {
  CounselorMember = `counselor/member`,
  CounselorMemberLookup = `counselor/member/lookup`,
  CounselorMemberLookupHistory = `counselor/member/lookup-history`,
  CounselorMemberTestMembers = `counselor/member/test-members`,
  CounselorMemberCreate = `counselor/member/create`,

  CallLogs = `counselor/call-logs`,
  CallLogHistory = `counselor/call-logs/history`,
  CallLogsCreate = `counselor/call-logs/create`,

  FollowUps = `counselor/follow-ups`,
  FollowUpsOpen = `counselor/follow-ups/open`,
  FollowUpsCompleted = `counselor/follow-ups/completed`,
  FollowUpManagement = `counselor/follow-ups/management`,

  Resources = `counselor/resources`,
  ResourcesBenefitLevel = `counselor/resources/benefit`,
  ResourcesCompanyLevel = `counselor/resources/company`,
  ResourcesCompliance = `counselor/resources/compliance`,
  ResourcesContacts = `counselor/resources/contacts`,

  Reports = `counselor/reports`,
  ReportsExecute = `counselor/reports/execute`,
  ReportsToday = `counselor/reports/today`,
  ReportsHistory = `counselor/reports/history`,

  Agents = `counselor/agents`,
  AgentsManage = `counselor/agents/manage`,
  AgentsCompanyAssignment = `counselor/agents/company-Assignment`,
  AgentsAssignment = `counselor/agents/assignment`,
  AgentsCarrierInfo = `counselor/agents/carrier-Info`,
  AgentsTestServers = `counselor/agents/test-servers`,
  AgentsReviewSASS = `counselor/agents/review-sass`,
  AuthenticatorTest = `counselor/agents/test-auth`,
}

export const AgentPaths = {
  CounselorMember: `/${AgentModulePaths.CounselorMember}`,
  CounselorMemberLookup: `/${AgentModulePaths.CounselorMemberLookup}`,
  CounselorMemberLookupHistory: `/${AgentModulePaths.CounselorMemberLookupHistory}`,
  CounselorMemberTestMembers: `/${AgentModulePaths.CounselorMemberTestMembers}`,
  CounselorMemberCreate: `/${AgentModulePaths.CounselorMemberCreate}`,

  CallLogs: `/${AgentModulePaths.CallLogs}`,
  CallLogsCreate: `/${AgentModulePaths.CallLogsCreate}`,
  CallLogHistory: `/${AgentModulePaths.CallLogHistory}`,

  FollowUps: `/${AgentModulePaths.FollowUps}`,
  FollowUpsOpen: `/${AgentModulePaths.FollowUpsOpen}`,
  FollowUpsCompleted: `/${AgentModulePaths.FollowUpsCompleted}`,
  FollowUpManagement: `/${AgentModulePaths.FollowUpManagement}`,

  Resources: `/${AgentModulePaths.Resources}`,
  ResourcesBenefitLevel: `/${AgentModulePaths.ResourcesBenefitLevel}`,
  ResourcesCompanyLevel: `/${AgentModulePaths.ResourcesCompanyLevel}`,
  ResourcesCompliance: `/${AgentModulePaths.ResourcesCompliance}`,
  ResourcesContacts: `/${AgentModulePaths.ResourcesContacts}`,

  Reports: `/${AgentModulePaths.Reports}`,
  ReportsExecute: `/${AgentModulePaths.ReportsExecute}`,
  ReportsToday: `/${AgentModulePaths.ReportsToday}`,
  ReportsHistory: `/${AgentModulePaths.ReportsHistory}`,

  Agents: `/${AgentModulePaths.Agents}`,
  AgentsManage: `/${AgentModulePaths.AgentsManage}`,
  AgentsCompanyAssignment: `/${AgentModulePaths.AgentsCompanyAssignment}`,
  AgentsAssignment: `/${AgentModulePaths.AgentsAssignment}`,
  AgentsCarrierInfo: `/${AgentModulePaths.AgentsCarrierInfo}`,
  AgentsTestServers: `/${AgentModulePaths.AgentsTestServers}`,
  AgentsReviewSASS: `/${AgentModulePaths.AgentsReviewSASS}`,
  AuthenticatorTest: `/${AgentModulePaths.AuthenticatorTest}`,
};

export enum MemberModulePaths {
  Dashboard = `dashboard`,

  Benefits = `benefits`,
  BenefitsAvailable = `benefits/available-benefits`,
  BenefitsMyBenefits = `benefits/my-benefits`,
  BenefitsDashboard = `benefits/available-enrollments`,
  BenefitsChangeRequests = `benefits/change-requests`,
  BenefitsLifeEventRequests = `benefits/life-event-requests`,
  BenefitsBeneficiaries = `benefits/beneficiaries`,
  BenefitsDependentVerification = `benefits/dependent-verification`,
  BenefitEnrollment = `benefits/enrollment`,
  PaymentInformation = `benefits/payment-information`,
  DocumentsBenefitsSummaries = `benefits/benefit-summaries`,

  Profile = `profile`,
  ProfileMember = `profile/member`,
  ProfileDependents = `profile/dependents`,
  ProfileBeneficiaries = `profile/beneficiaries`,

  Accounting = `accounting`,
  AccountingTransactions = `accounting/transactions`,
  AccountingPaymentInformation = `accounting/payment-information`,

  Documents = `documents`,
  DocumentsBenefits = `documents/benefits`,
  DocumentsCompany = `documents/company`,
  DocumentsCompliance = `documents/compliance`,
  DocumentsContacts = `documents/contacts`,
  DocumentsForm1095 = `documents/form-1095`,
  DocumentsW2 = `documents/w2`,

  Relations = `relations`,
  RelationsActivityLog = `relations/activity-log`,
  RelationsOpenFollowUps = `relations/open-follow-ups`,
  RelationsCompletedFollowUps = `relations/completed-follow-ups`,

  Payroll = `payroll`,
  PayrollDashboard = `payroll/dashboard`,
  PayrollAddress = `payroll/address`,
  PayrollDeductions = `payroll/deductions`,
  PayrollDirectDeposit = `payroll/direct-deposit`,
  PayrollFederalTaxDetails = `payroll/federal-tax-details`,
  PayrollStateTaxDetails = `payroll/state-tax-details`,
  PayrollPTOSickHours = `payroll/pto-sick-hours`,
  PayrollAnnualStatements = `payroll/annual-statements`,
  PayrollPayStubs = `payroll/paystubs`,
}

export const MemberPaths = {
  Dashboard: `/${MemberModulePaths.Dashboard}`,

  Benefits: `/${MemberModulePaths.Benefits}`,
  BenefitsAvailable: `/${MemberModulePaths.BenefitsAvailable}`,
  BenefitsMyBenefits: `/${MemberModulePaths.BenefitsMyBenefits}`,
  BenefitsDashboard: `/${MemberModulePaths.BenefitsDashboard}`,
  BenefitsChangeRequests: `/${MemberModulePaths.BenefitsChangeRequests}`,
  BenefitsLifeEventRequests: `/${MemberModulePaths.BenefitsLifeEventRequests}`,
  BenefitsBeneficiaries: `/${MemberModulePaths.BenefitsBeneficiaries}`,
  BenefitsDependentVerification: `/${MemberModulePaths.BenefitsDependentVerification}`,
  PaymentInformation: `/${MemberModulePaths.PaymentInformation}`,

  Profile: `/${MemberModulePaths.Profile}`,
  ProfileMember: `/${MemberModulePaths.ProfileMember}`,
  ProfileDependents: `/${MemberModulePaths.ProfileDependents}`,
  ProfileBeneficiaries: `/${MemberModulePaths.ProfileBeneficiaries}`,

  Accounting: `/${MemberModulePaths.Accounting}`,
  AccountingTransactions: `/${MemberModulePaths.AccountingTransactions}`,
  AccountingPaymentInformation: `/${MemberModulePaths.AccountingPaymentInformation}`,

  Documents: `/${MemberModulePaths.Documents}`,
  DocumentsBenefits: `/${MemberModulePaths.DocumentsBenefits}`,
  DocumentsCompany: `/${MemberModulePaths.DocumentsCompany}`,
  DocumentsCompliance: `/${MemberModulePaths.DocumentsCompliance}`,
  DocumentsContacts: `/${MemberModulePaths.DocumentsContacts}`,
  DocumentsBenefitsSummaries: `/${MemberModulePaths.DocumentsBenefitsSummaries}`,
  DocumentsForm1095: `/${MemberModulePaths.DocumentsForm1095}`,
  DocumentsW2: `/${MemberModulePaths.DocumentsW2}`,

  Relations: `/${MemberModulePaths.Relations}`,
  RelationsActivityLog: `/${MemberModulePaths.RelationsActivityLog}`,
  RelationsOpenFollowUps: `/${MemberModulePaths.RelationsOpenFollowUps}`,
  RelationsCompletedFollowUps: `/${MemberModulePaths.RelationsCompletedFollowUps}`,

  BenefitEnrollment: `/${MemberModulePaths.BenefitEnrollment}`,

  Payroll: `/${MemberModulePaths.Payroll}`,
  PayrollDashboard: `/${MemberModulePaths.PayrollDashboard}`,
  PayrollPayStubs: `/${MemberModulePaths.PayrollPayStubs}`,
  PayrollAnnualStatements: `/${MemberModulePaths.PayrollAnnualStatements}`,
  PayrollAddress: `/${MemberModulePaths.PayrollAddress}`,
  PayrollDeductions: `/${MemberModulePaths.PayrollDeductions}`,
  PayrollDirectDeposit: `/${MemberModulePaths.PayrollDirectDeposit}`,
  PayrollFederalTaxDetails: `/${MemberModulePaths.PayrollFederalTaxDetails}`,
  PayrollStateTaxDetails: `/${MemberModulePaths.PayrollStateTaxDetails}`,
  PayrollPTOSickHours: `/${MemberModulePaths.PayrollPTOSickHours}`,
};
